export const truncateCompanyText = (text, maxLength) => {
  return text.length > maxLength ? text.slice(0, maxLength) + ".." : text;
};


/**
 * Converts text to proper case (title case) with comprehensive error handling
 * @param {string|any} text - The text to convert to proper case
 * @param {string} fallback - Fallback text if input is invalid (default: "N/A")
 * @returns {string} The properly formatted text or fallback
 */
export function toProperCase(text, fallback = "N/A") {
    // Handle null, undefined, or empty values
    if (text === null || text === undefined) {
      return fallback;
    }

    // Convert to string if not already a string
    const stringValue = typeof text === 'string' ? text : String(text);
    
    // Handle empty string or whitespace-only strings
    if (!stringValue || stringValue.trim() === '') {
      return fallback;
    }

    // Handle very long strings (prevent potential performance issues)
    if (stringValue.length > 100) {
      console.warn('toProperCase: Input text is very long, truncating...');
      const truncated = stringValue.substring(0, 100);
      return truncated
        .toLowerCase()
        .replace(/\b\w/g, (char) => char.toUpperCase())
        .trim();
    }

    // Main conversion logic
    return stringValue
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase())
      .trim();
}


